var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"status-container"},[_vm._t("default"),_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }